import { useEffect, useRef } from 'react';
import { scrollElementIntoHorizontalView } from '@/common/utils';
import HorizontalScrollView from '../HorizontalScrollView/HorizontalScrollView';
import Tab from './Tab';
import type { TabsProps } from './Tabs.types';

const SCROLL_OFFSET = 32;

export default function Tabs<ValueType extends string>(props: TabsProps<ValueType>) {
  const { options, value, platform, onValueChange } = props;

  const containerRef = useRef<HTMLDivElement>(null);
  const activeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    scrollElementIntoHorizontalView(containerRef.current, activeButtonRef.current, SCROLL_OFFSET);
  }, [value, options]);

  return (
    <HorizontalScrollView
      ref={containerRef}
      className="flex border-b border-pmw-separator-light dark:border-pmw-separator-dark"
      overlayClassName="mx-2"
      platform={platform}
    >
      {options.map((option) => (
        <Tab
          ref={(ref) => {
            if (value === option.value) {
              activeButtonRef.current = ref;
            }
          }}
          key={option.value}
          label={option.label}
          icon={option.icon}
          isActive={option.value === value}
          onClick={() => onValueChange?.(option.value)}
        />
      ))}
    </HorizontalScrollView>
  );
}
